
import { DASHBOARD } from '../constants'
import { apiReducer } from 'utils/API'
import { USER_CLEAR } from 'modules/Login/constants'

export default apiReducer({
  entity: DASHBOARD,
  defaultData: [],
  resetActions: [USER_CLEAR],
})